<template>
  <div>
    <field-list :field-delivery="allFields" />
  </div>
</template>

<script>


import FieldList from "@/components/FieldList";
import {fieldService} from "@/services/field.service";

export default {
  name: "FieldOverview",
  data() {
    return {
      allFields: []
    }
  },
  created() {
fieldService.getField().then(res => {
  this.allFields = res.items
})
  },
  components: {FieldList},
  methods: {},
}
</script>

<style scoped>

</style>